/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type TemporarySessionBannerSessionFragment = {
  __typename?: 'TemporaryBackofficeSession'
  id: string
  type: Types.TemporaryBackofficeSessionType
  targetUserName: string | null
  targetUserEmail: string | null
  createdAt: string
  expiresAt: string
  closedAt: string | null
  permissions: {
    __typename?: 'TemporaryBackofficeSessionPermissions'
    organizationId: string
    organizationName: string | null
  }
}

export type TemporarySessionBannerQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type TemporarySessionBannerQuery = {
  __typename?: 'Query'
  currentTemporaryBackofficeSession: {
    __typename?: 'TemporaryBackofficeSession'
    id: string
    type: Types.TemporaryBackofficeSessionType
    targetUserName: string | null
    targetUserEmail: string | null
    createdAt: string
    expiresAt: string
    closedAt: string | null
    permissions: {
      __typename?: 'TemporaryBackofficeSessionPermissions'
      organizationId: string
      organizationName: string | null
    }
  } | null
}

export type ProlongTemporarySessionMutationVariables = Types.Exact<{
  input: Types.ProlongTemporaryBackofficeSessionInput
}>

export type ProlongTemporarySessionMutation = {
  __typename?: 'Mutation'
  prolongTemporaryBackofficeSession: {
    __typename?: 'TemporaryBackofficeSession'
    id: string
    type: Types.TemporaryBackofficeSessionType
    targetUserName: string | null
    targetUserEmail: string | null
    createdAt: string
    expiresAt: string
    closedAt: string | null
    lifecycleEvents: Array<{
      __typename?: 'TemporaryBackofficeSessionLifecycleEvent'
      type: Types.TemporaryBackofficeSessionLifecycleEventType
      timestamp: string
      expiresAt: string | null
    }>
    permissions: {
      __typename?: 'TemporaryBackofficeSessionPermissions'
      organizationId: string
      organizationName: string | null
    }
  }
}

export const TemporarySessionBannerSessionFragmentDoc = gql`
    fragment TemporarySessionBannerSession on TemporaryBackofficeSession {
  id
  type
  targetUserName
  targetUserEmail
  createdAt
  expiresAt
  closedAt
  permissions {
    organizationId
    organizationName
  }
}
    `
export const TemporarySessionBannerDocument = gql`
    query TemporarySessionBanner {
  currentTemporaryBackofficeSession {
    ...TemporarySessionBannerSession
  }
}
    ${TemporarySessionBannerSessionFragmentDoc}`

/**
 * __useTemporarySessionBannerQuery__
 *
 * To run a query within a React component, call `useTemporarySessionBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemporarySessionBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemporarySessionBannerQuery({
 *   variables: {
 *   },
 * });
 */
export function useTemporarySessionBannerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TemporarySessionBannerQuery,
    TemporarySessionBannerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    TemporarySessionBannerQuery,
    TemporarySessionBannerQueryVariables
  >(TemporarySessionBannerDocument, options)
}
export function useTemporarySessionBannerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TemporarySessionBannerQuery,
    TemporarySessionBannerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    TemporarySessionBannerQuery,
    TemporarySessionBannerQueryVariables
  >(TemporarySessionBannerDocument, options)
}
// @ts-ignore
export function useTemporarySessionBannerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TemporarySessionBannerQuery,
    TemporarySessionBannerQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TemporarySessionBannerQuery,
  TemporarySessionBannerQueryVariables
>
export function useTemporarySessionBannerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TemporarySessionBannerQuery,
        TemporarySessionBannerQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TemporarySessionBannerQuery | undefined,
  TemporarySessionBannerQueryVariables
>
export function useTemporarySessionBannerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TemporarySessionBannerQuery,
        TemporarySessionBannerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    TemporarySessionBannerQuery,
    TemporarySessionBannerQueryVariables
  >(TemporarySessionBannerDocument, options)
}
export type TemporarySessionBannerQueryHookResult = ReturnType<
  typeof useTemporarySessionBannerQuery
>
export type TemporarySessionBannerLazyQueryHookResult = ReturnType<
  typeof useTemporarySessionBannerLazyQuery
>
export type TemporarySessionBannerSuspenseQueryHookResult = ReturnType<
  typeof useTemporarySessionBannerSuspenseQuery
>
export type TemporarySessionBannerQueryResult = Apollo.QueryResult<
  TemporarySessionBannerQuery,
  TemporarySessionBannerQueryVariables
>
export const ProlongTemporarySessionDocument = gql`
    mutation ProlongTemporarySession($input: ProlongTemporaryBackofficeSessionInput!) {
  prolongTemporaryBackofficeSession(input: $input) {
    ...TemporarySessionBannerSession
    lifecycleEvents {
      type
      timestamp
      expiresAt
    }
  }
}
    ${TemporarySessionBannerSessionFragmentDoc}`
export type ProlongTemporarySessionMutationFn = Apollo.MutationFunction<
  ProlongTemporarySessionMutation,
  ProlongTemporarySessionMutationVariables
>

/**
 * __useProlongTemporarySessionMutation__
 *
 * To run a mutation, you first call `useProlongTemporarySessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProlongTemporarySessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prolongTemporarySessionMutation, { data, loading, error }] = useProlongTemporarySessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProlongTemporarySessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProlongTemporarySessionMutation,
    ProlongTemporarySessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ProlongTemporarySessionMutation,
    ProlongTemporarySessionMutationVariables
  >(ProlongTemporarySessionDocument, options)
}
export type ProlongTemporarySessionMutationHookResult = ReturnType<
  typeof useProlongTemporarySessionMutation
>
export type ProlongTemporarySessionMutationResult =
  Apollo.MutationResult<ProlongTemporarySessionMutation>
export type ProlongTemporarySessionMutationOptions = Apollo.BaseMutationOptions<
  ProlongTemporarySessionMutation,
  ProlongTemporarySessionMutationVariables
>
